import { IconBadge } from '@coop/components';
import { UserIcon } from '@coop/icons';

import A11yTextWrapper from '../../../common/components/A11yTextWrapper/A11yTextWrapper';
import { usePunchoutOrgUnit } from '../../../ecommerce/hooks/usePunchoutOrgUnit';
import styles from './PunchoutNotice.module.scss';

const PunchoutNotice = () => {
    const query = usePunchoutOrgUnit();

    const punchoutOrgUnitName = query.data?.orgUnit.name;

    if (!query.isSuccess || !punchoutOrgUnitName) {
        return null;
    }

    return (
        <div className={styles.NoticeContainer}>
            <div className={styles.Notice}>
                <div className={styles.User}>
                    <div className={styles.UserCard}>
                        <IconBadge theme="white" size="medium" icon={<UserIcon />} />
                        <A11yTextWrapper
                            className={styles.Text}
                            a11yType="visuallyHiddenText"
                            a11yText={`Du handlar åt ${punchoutOrgUnitName}`}
                        >
                            <span aria-hidden>Du handlar åt</span>
                            <span aria-hidden className={styles.Name}>
                                {punchoutOrgUnitName}
                            </span>
                        </A11yTextWrapper>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PunchoutNotice;
